export default {
    headers: [],
    data: [],
    action_for: '', // action_for is equal to the operation being performed.
    users :{
        data:[],
        default_password: "",
        office:""
    },
    offices : {
        data: [],
        office_group: ""
    },
    loading: false
}
